var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconWorkspace = function SvgIconWorkspace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.75q-.04.508-.43.742l-6.601 3.672a.73.73 0 0 1-.469.157.73.73 0 0 1-.469-.157L4.93 16.492q-.39-.234-.43-.742v-7.5q.04-.508.43-.742l6.601-3.672A.73.73 0 0 1 12 3.68q.273 0 .469.156l6.601 3.672q.39.234.43.742zM12 5.477 6.18 8.758v6.485l5.82 3.28 5.82-3.28V8.758z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconWorkspace);
export { ForwardRef as ReactComponent };